export default {
  amex: { color: 'black', name: 'Amex',},
  diners: { color: 'black', name: 'Diners',},
  elo: { color: 'black', name: 'Elo',},
  hipercard: { color: 'black', name: 'Hipercard',},
  mastercard: { color: 'black', name: 'Mastercard',},
  visa: { color: 'black', name: 'Visa',},
}